import React from 'react';
import SvgIcon from 'utils/SvgIcon';

const AnnotationIcon = ({ fillColor, hoverFill, style }) => (
  <SvgIcon
    {...{ fillColor, hoverFill, style }}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2583 2.59101C12.9654 2.29811 12.4905 2.29811 12.1976 2.59101L10.7834 4.00522L13.2583 6.48009L14.6725 5.06588C14.9654 4.77299 14.9654 4.29811 14.6725 4.00522L13.2583 2.59101ZM12.1976 7.54076L9.72277 5.06588L3.92905 10.8596C2.79905 11.9896 2.64109 13.4393 2.5665 14.697C3.82426 14.6224 5.27392 14.4645 6.40393 13.3345L12.1976 7.54076ZM11.137 1.53035C12.0157 0.651668 13.4403 0.651668 14.319 1.53035L15.7332 2.94456C16.6119 3.82324 16.6119 5.24786 15.7332 6.12654L7.46459 14.3951C5.80216 16.0576 3.57505 16.1595 2.28942 16.2184C2.11573 16.2263 1.95923 16.2335 1.82363 16.2436L0.955078 16.3084L1.01989 15.4399C1.03001 15.3043 1.03718 15.1478 1.04513 14.9741C1.10399 13.6885 1.20596 11.4614 2.86839 9.79893L11.137 1.53035Z"
    />
    <path d="M7.63178 16.0525C7.7642 16.1077 7.91514 16.1389 8.07533 16.1389H15.8065C16.3315 16.1389 16.6318 15.8031 16.6318 15.3889C16.6318 14.9747 16.3315 14.6389 15.8065 14.6389H9.42361L7.63178 16.0525Z" />
  </SvgIcon>
);

export default AnnotationIcon;
